import {isFeatureEnabled} from 'feature-flags';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {EntityResourceIds} from '@dms/api/shared';
import {useGetWorkshopInterestQuery} from '@dms/api/workshop';
import {featureFlags} from '@dms/feature-flags';
import {
  ActivitySidebarAction,
  ActivitySidebarV2,
  CommunicationThreadTab,
} from '@dms/features/activity-panel';
import {buildCustomNoticesSidebarAction} from '@dms/features/custom-notices';
import i18n from '@dms/i18n';
import {usePermissions, useWorkshopInterestEditPermissions} from '@dms/shared';

import {buildArray} from 'shared/web';

import {ActivityTab} from './ActivityPanel/ActivityTab';
import {WorkshopInterestCommentsTab} from './ActivityPanel/WorkshopInterestCommentsTab';

type WorkshopInterestActivityPanelProps = {
  interestId: string;
};

export function WorkshopInterestActivityPanel(props: WorkshopInterestActivityPanelProps) {
  const {hasReadCommentsPermission} = useWorkshopInterestEditPermissions({
    interestId: props.interestId,
  });

  const {data: workshopInterest} = useGetWorkshopInterestQuery({id: props.interestId});

  const [canReadSalesActivities] = usePermissions({
    permissionKeys: ['readSalesActivities'],
  });

  const actions = buildArray<ActivitySidebarAction>()
    .when(canReadSalesActivities, {
      id: 'activity',
      label: i18n.t('entity.activityPanel.activity.title'),
      icon: 'sidebar/activity',
      component: <ActivityTab interestId={props.interestId} />,
    })
    .when(
      canReadSalesActivities &&
        isFeatureEnabled(featureFlags.MESSAGE_SYNCHRONIZATION) &&
        isNotNilOrEmpty(workshopInterest?.customerId),
      {
        id: 'communication',
        label: i18n.t('entity.activityPanel.communicationThread.title'),
        icon: 'communication/thread',
        component: (
          <CommunicationThreadTab
            customerId={workshopInterest?.customerId ?? ''}
            recordId={props.interestId}
            resourceId={EntityResourceIds.workshopInterest}
          />
        ),
        disablePadding: true,
      }
    )
    .when(canReadSalesActivities && hasReadCommentsPermission, {
      id: 'comments',
      label: i18n.t('entity.activityPanel.comments.title'),
      icon: 'communication/comment',
      component: <WorkshopInterestCommentsTab interestId={props.interestId} />,
    })
    .whenFeatureEnabled(
      featureFlags.CUSTOM_NOTICES,
      buildCustomNoticesSidebarAction({
        resourceId: EntityResourceIds.workshopInterest,
        recordId: props.interestId,
      })
    );

  return <ActivitySidebarV2 actions={actions} />;
}
